import { RouteConfig } from 'vue-router';
import Auth from './AuthPage.vue';

const routes: Array<RouteConfig> = [
    { 
        path: '/auth', 
        name: 'Auth', 
        component: Auth,
        meta: {
            forbiddenAuth: true,
        },
    },
];

export default routes;